'use strict';

(function() {

    const selectores_cookiesWhatsappKlaviyo = {
        whatsapp: '.Button-whatsapp', 
        klaviyo: '.kl-teaser-VTb2Bf', 
        banner: '#cx-layer'
    };

    const ajustesPosicion_cookiesWhatsappKlaviyo = {
        posicionSubidaWhatsapp: '90px',
        posicionSubidaKlaviyo: '57px',
        posicionOriginalWhatsapp: '40px', 
        posicionOriginalKlaviyo: '0px'
    };

    const gestionarPosicionBotones_cookiesWhatsappKlaviyo = () => {
        const nodoBanner = document.querySelector(selectores_cookiesWhatsappKlaviyo.banner);
        const nodoWhatsapp = document.querySelector(selectores_cookiesWhatsappKlaviyo.whatsapp);
        const nodoKlaviyo = document.querySelector(selectores_cookiesWhatsappKlaviyo.klaviyo);

        if (nodoBanner && (nodoBanner.offsetHeight > 0 || nodoBanner.getClientRects().length > 0)) {
            
            if (nodoWhatsapp) {
                nodoWhatsapp.style.bottom = ajustesPosicion_cookiesWhatsappKlaviyo.posicionSubidaWhatsapp;
            }
            if (nodoKlaviyo) {
                nodoKlaviyo.style.bottom = ajustesPosicion_cookiesWhatsappKlaviyo.posicionSubidaKlaviyo;
            }

        } else {
            if (nodoWhatsapp) {
                nodoWhatsapp.style.bottom = ajustesPosicion_cookiesWhatsappKlaviyo.posicionOriginalWhatsapp;
            }
            if (nodoKlaviyo) {
                nodoKlaviyo.style.bottom = ajustesPosicion_cookiesWhatsappKlaviyo.posicionOriginalKlaviyo;
            }
        }
    };

    const observer_cookiesWhatsappKlaviyo = new MutationObserver(() => {
        gestionarPosicionBotones_cookiesWhatsappKlaviyo();
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => iniciar_cookiesWhatsappKlaviyo());
    } else {
        iniciar_cookiesWhatsappKlaviyo();
    }

    function iniciar_cookiesWhatsappKlaviyo() {
        gestionarPosicionBotones_cookiesWhatsappKlaviyo();
        observer_cookiesWhatsappKlaviyo.observe(document.body, { 
            childList: true, 
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class'] 
        });
    }

})();